import { getFunctions, httpsCallable } from 'firebase/functions';

const functions = getFunctions();

function checkoutUrls() {
  const origin = window.location.origin;
  const base = `${origin}/?page=tiago-ai`;
  return {
    successUrl: `${base}&tiago=success`,
    cancelUrl: `${base}&tiago=cancel`,
  };
}

export async function startTiagoCheckout(planId) {
  const fn = httpsCallable(functions, 'createTiagoCheckout');
  const { successUrl, cancelUrl } = checkoutUrls();
  const res = await fn({ planId, successUrl, cancelUrl });
  const url = res.data?.url;
  if (!url) throw new Error('Checkout could not be started. Stripe price may not be configured yet.');
  window.location.href = url;
}

export async function openTiagoBillingPortal() {
  const fn = httpsCallable(functions, 'createTiagoPortal');
  const res = await fn({ returnUrl: `${window.location.origin}/?page=tiago-ai` });
  const url = res.data?.url;
  if (!url) throw new Error('No billing portal available');
  window.location.href = url;
}
